import ParticipantCreate from "./ParticipantCreate"
import ParticipantList from "./ParticipantList"

const ParticipantCRUD = {
  create: ParticipantCreate,
  list: ParticipantList,
}

export default ParticipantCRUD
